import React from "react";
import { Navigate, useLocation } from "react-router-dom";
import { getSignInPathWithRedirect } from "routes/signInRedirect";

/** Sends a signed-out visitor to sign-in, preserving the current location as the return path. */
const SignInRedirectRoute = () => {
	const location = useLocation();

	return <Navigate to={getSignInPathWithRedirect(`${location.pathname}${location.search}`)} replace />;
};

export default SignInRedirectRoute;
